<template>
  <div>
    <a-card class="customer-filter" size="small">
      <feedback-filter-form v-model="filterForm" @change="onSearch" @reset="onReset" />
    </a-card>
    <a-card title="反馈列表">
      <feedback-list :loading="loading" :feedback-list="feedBackList" :pagination="pagination" @page-change="handlePageChange" @refresh="getFeedbackList" />
    </a-card>
  </div>
</template>

<script>
import { feedbackList } from '@/api/feedback/feedback';
import { feedbackStatus, feedbackTypes } from '@/utils/dictionary';
import FeedbackFilterForm from './components/FeedbackFilterForm.vue';
import FeedbackList from './components/FeedbackList.vue';

export default {
  name: 'Feedback',
  components: {
    FeedbackList,
    FeedbackFilterForm
  },
  data() {
    return {
      feedbackStatus,
      feedbackTypes,
      loading: true,
      filterForm: {
        title: this.$route.query.keyword || '',
        status: undefined,
        user_id: null,
        type: undefined
      },
      feedBackList: [],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      }
    };
  },
  created() {
    this.getFeedbackList();
  },
  methods: {
    getFeedbackList() {
      this.loading = true;
      feedbackList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.loading = false;
          this.feedBackList = res.data.items;
          this.pagination.total = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSearch(filter) {
      this.filterForm = filter;
      this.pagination.current = 1;
      this.getFeedbackList();
    },
    onReset(form) {
      this.filterForm = {
        ...form
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 20;

      // 清空路由query参数
      if (Object.keys(this.$route.query).length > 0) {
        this.$router
          .replace({
            path: this.$route.path,
            query: {}
          })
          .catch(() => {
            // 忽略导航重复错误
          });
      }

      this.getFeedbackList();
    },
    handlePageChange(pagination) {
      pagination.current = pagination.pageSize !== this.pagination.pageSize ? 1 : pagination.current;
      this.pagination = pagination;
      this.getFeedbackList();
    }
  }
};
</script>

<style lang="less" scoped>
.customer-filter {
  margin-bottom: 16px;

  :deep(.ant-page-header) {
    padding: 0;
  }

  :deep(.ant-form-item) {
    margin-bottom: 8px;
    display: flex;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }
}
</style>
